@if (loader) {
  <div id="wrapper">
    <div class="profile-main-loader">
      <div class="loader"></div>
    </div>
    @if (loaderType === "bar") {
      <div style="position: absolute; top: 0px" class="w-100">
        <mat-progress-bar color="primary" mode="indeterminate"> </mat-progress-bar>
      </div>
    }
    @if (loaderType === "circle") {
      <div class="spinner-container">
        <div class="spinner-border text-primary" role="status"></div>
      </div>
    }
  </div>
}
